import { render, staticRenderFns } from "./orderSummary.vue?vue&type=template&id=522bedda&scoped=true&"
import script from "./orderSummary.vue?vue&type=script&lang=js&"
export * from "./orderSummary.vue?vue&type=script&lang=js&"
import style0 from "./orderSummary.vue?vue&type=style&index=0&id=522bedda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522bedda",
  null
  
)

export default component.exports